import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import {
  ArrowRightOutlined,
  IdcardOutlined,
  LockOutlined,
  LoginOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import Swal from "sweetalert2";
import "./css/main.login.css";
import "./css/login-page.css";
import { getAssetUrl } from "../../utils/assetUrl";

type AuthMode = "login" | "register";

type RegisterValues = {
  username: string;
  phone: string;
  password: string;
  confirmPassword: string;
};

type AuthPanelProps = {
  mode: AuthMode;
  userName: string;
  password: string;
  registerValues: RegisterValues;
  onUserNameChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onRegisterValueChange: (
    key: keyof RegisterValues
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (mode: AuthMode) => void;
  onSwitchPeer: () => void;
};

const AuthPanel: React.FC<AuthPanelProps> = ({
  mode,
  userName,
  password,
  registerValues,
  onUserNameChange,
  onPasswordChange,
  onRegisterValueChange,
  onSubmit,
  onSwitchPeer,
}) => {
  const idPrefix = mode;

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(mode);
  };

  return (
    <section
      id={`auth-panel-${mode}`}
      className={`login-auth-modal login-auth-modal--${mode}`}
      aria-label={mode === "login" ? "Đăng nhập" : "Đăng ký"}
    >
      <div className="login-auth-modal__visual">
        <img
          className="login-auth-modal__robot"
          src={getAssetUrl("/assets/robot.png")}
          alt=""
          width={387}
          height={491}
        />
      </div>

      <div className="login-auth-modal__panel">
        <div className="login-auth-modal__body">
          <form
            className={`login-auth-modal__form login-auth-modal__form--${mode}`}
            onSubmit={handleSubmit}
          >
          <div className="login-auth-field">
            <label
              className="login-auth-field__label"
              htmlFor={`${idPrefix}-username`}
            >
              TÀI KHOẢN
            </label>
            <div className="login-auth-field__input-wrap">
              <IdcardOutlined className="login-auth-field__icon" />
              <input
                id={`${idPrefix}-username`}
                className="login-auth-field__input"
                type="text"
                placeholder="NHẬP TÊN TÀI KHOẢN"
                autoComplete="username"
                value={mode === "login" ? userName : registerValues.username}
                onChange={(event) =>
                  mode === "login"
                    ? onUserNameChange(event.target.value)
                    : onRegisterValueChange("username")(event)
                }
              />
            </div>
          </div>

          {mode === "register" && (
            <div className="login-auth-field">
              <label
                className="login-auth-field__label"
                htmlFor={`${idPrefix}-phone`}
              >
                SỐ ĐIỆN THOẠI
              </label>
              <div className="login-auth-field__input-wrap">
                <IdcardOutlined className="login-auth-field__icon" />
                <input
                  id={`${idPrefix}-phone`}
                  className="login-auth-field__input"
                  type="tel"
                  inputMode="numeric"
                  placeholder="NHẬP SỐ ĐIỆN THOẠI (ZALO)"
                  autoComplete="tel"
                  value={registerValues.phone}
                  onChange={onRegisterValueChange("phone")}
                />
              </div>
            </div>
          )}

          {mode === "login" ? (
            <div className="login-auth-field">
              <label
                className="login-auth-field__label"
                htmlFor={`${idPrefix}-password`}
              >
                MẬT KHẨU
              </label>
              <div className="login-auth-field__input-wrap">
                <LockOutlined className="login-auth-field__icon" />
                <input
                  id={`${idPrefix}-password`}
                  className="login-auth-field__input"
                  type="password"
                  placeholder="********"
                  autoComplete="current-password"
                  value={password}
                  onChange={(event) => onPasswordChange(event.target.value)}
                />
              </div>
            </div>
          ) : (
            <div className="login-auth-field-row">
              <div className="login-auth-field login-auth-field--half">
                <label
                  className="login-auth-field__label"
                  htmlFor={`${idPrefix}-password`}
                >
                  MẬT KHẨU
                </label>
                <div className="login-auth-field__input-wrap">
                  <LockOutlined className="login-auth-field__icon" />
                  <input
                    id={`${idPrefix}-password`}
                    className="login-auth-field__input"
                    type="password"
                    placeholder="********"
                    autoComplete="new-password"
                    value={registerValues.password}
                    onChange={onRegisterValueChange("password")}
                  />
                </div>
              </div>
              <div className="login-auth-field login-auth-field--half">
                <label
                  className="login-auth-field__label"
                  htmlFor={`${idPrefix}-confirm-password`}
                >
                  NHẬP LẠI MẬT KHẨU
                </label>
                <div className="login-auth-field__input-wrap">
                  <SafetyCertificateOutlined className="login-auth-field__icon" />
                  <input
                    id={`${idPrefix}-confirm-password`}
                    className="login-auth-field__input"
                    type="password"
                    placeholder="********"
                    autoComplete="new-password"
                    value={registerValues.confirmPassword}
                    onChange={onRegisterValueChange("confirmPassword")}
                  />
                </div>
              </div>
            </div>
          )}

            <button type="submit" className="login-auth-modal__submit">
              {mode === "login" ? "ĐĂNG NHẬP" : "ĐĂNG KÝ"}
              <ArrowRightOutlined className="login-auth-modal__submit-arrow" />
            </button>
          </form>

          <p className="login-auth-modal__switch">
            <LoginOutlined className="login-auth-modal__switch-icon" />
            {mode === "login"
              ? "CHƯA CÓ TÀI KHOẢN? "
              : "ĐÃ CÓ TÀI KHOẢN? "}
            <button
              type="button"
              className="login-auth-modal__switch-btn"
              onClick={onSwitchPeer}
            >
              {mode === "login" ? "ĐĂNG KÝ" : "ĐĂNG NHẬP"}
            </button>
          </p>
        </div>

        <footer className="login-auth-modal__footer">
          <span className="login-auth-modal__footer-line" aria-hidden />
          <span>SECURE_CHANNEL_V3</span>
          <span className="login-auth-modal__footer-line" aria-hidden />
        </footer>
      </div>
    </section>
  );
};

const Login: React.FC = () => {
  const [authView, setAuthView] = useState<AuthMode>("login");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [registerValues, setRegisterValues] = useState<RegisterValues>({
    username: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const handleRegisterValueChange =
    (key: keyof RegisterValues) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setRegisterValues((current) => ({
        ...current,
        [key]: event.target.value,
      }));
    };

  const handleLogin = async () => {
    if (userName.trim() === "" || password.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng nhập",
        text: "Vui lòng điền đầy đủ thông tin",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    }

    try {
      Swal.fire({
        title: "Đang xử lý...",
        html: "<p class='swal-loading-subtext'>Vui lòng chờ trong giây lát</p><div class='swal-loading-dots'><span class='swal-dot swal-dot-cyan'></span><span class='swal-dot swal-dot-orange'></span></div>",
        customClass: {
          popup: "custom-swal swal-loading-modal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
        allowOutsideClick: false,
        showConfirmButton: false,
      });

      await new Promise((resolve) => setTimeout(resolve, 1000));
      const response = await axios.post(`${process.env.REACT_APP_URL_API}/auth/login`, {
        username: userName,
        password,
      });

      localStorage.setItem(
        "user_info",
        JSON.stringify({
          userName: response.data.user.username,
          coins: response.data.user.coins,
          role: response.data.user.role,
          id: response.data.user._id,
        })
      );

      Cookies.set("access_token", response.data.access_token, {
        expires: 1 / 24,
        secure: false,
        sameSite: "Lax",
      });

      await new Promise((resolve) => setTimeout(resolve, 100));

      if (
        (response.status === 200 || response.status === 201) &&
        (response.data.user.role === "SUPERADMIN" ||
          response.data.user.role === "ADMIN")
      ) {
        Swal.fire({
          icon: "success",
          title: "Đăng nhập thành công",
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
        });
        setTimeout(() => {
          window.location.href = "/admin";
        }, 500);
      } else {
        Swal.fire({
          icon: "success",
          title: "Đăng nhập thành công",
          text: "Vui lòng đợi ít phút. ",
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
        });
        setTimeout(() => {
          window.location.href = "/";
        }, 500);
      }
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng nhập",
        text:
          err?.response?.status === 401
            ? "Tài khoản/mật khẩu không chính xác!"
            : err?.response?.data?.message || "Có lỗi xảy ra, vui lòng thử lại!",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
    }
  };

  const handleRegister = async () => {
    const username = registerValues.username.trim();
    const phone = registerValues.phone.trim();
    const regPassword = registerValues.password.trim();
    const confirmPassword = registerValues.confirmPassword.trim();

    if (!username || !phone || !regPassword || !confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng ký",
        text: "Vui lòng điền đầy đủ thông tin",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    }

    if (!/^\d{10}$/.test(phone)) {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng ký",
        text: "Số điện thoại phải có 10 chữ số",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    }

    if (regPassword.length < 6) {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng ký",
        text: "Mật khẩu ít nhất 6 ký tự",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    }

    if (regPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng ký",
        text: "Mật khẩu nhập lại không khớp",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_API}/auth/register`,
        {
          username,
          phone,
          password: regPassword,
        }
      );

      if (response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Đăng ký thành công",
          text: "Vui lòng đợi ít phút. ",
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
        });
        setRegisterValues({
          username: "",
          phone: "",
          password: "",
          confirmPassword: "",
        });
        setAuthView("login");
      }
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng ký",
        text: `${err?.response?.data?.message || "Có lỗi xảy ra, vui lòng thử lại!"}`,
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
    }
  };

  const handleAuthSubmit = (mode: AuthMode) => {
    if (mode === "login") {
      handleLogin();
    } else {
      handleRegister();
    }
  };

  return (
    <main className="login-page login-page--simple" aria-label="Đăng nhập">
      <div className="login-page--simple__content">
        <img
          className="login-page--simple__logo"
          src={getAssetUrl("/assets/logo.png")}
          alt="AI Tool VIP XX88D"
          width={855}
          height={149}
        />

        <div className="login-page--simple__auth-panels" aria-label="Tài khoản">
          <AuthPanel
            mode={authView}
            userName={userName}
            password={password}
            registerValues={registerValues}
            onUserNameChange={setUserName}
            onPasswordChange={setPassword}
            onRegisterValueChange={handleRegisterValueChange}
            onSubmit={handleAuthSubmit}
            onSwitchPeer={() =>
              setAuthView((current) => (current === "login" ? "register" : "login"))
            }
          />
        </div>
      </div>
    </main>
  );
};

export default Login;
